<template>
  <v-container fill-height fluid class="bg-image">
    <v-row justify="center" align="center">
      <v-dialog
        v-if="showMaintenance"
        v-model="showMaintenance"
        max-width="350px"
      >
        <v-container fluid class="ma-0 pa-0">
          <v-card class="elevation-0 ma-0 pa-0">
            <v-card-title class="primary white--text">
              Site em Manutenção
            </v-card-title>
            <v-card-text class="mt-2 text-center">
              O seu login não será bem sucedido enquanto o site estiver em manutenção. Agradecemos a sua compreensão!
            </v-card-text>
            <v-card-text class="justify-center">
              <v-avatar height="105" width="300" tile class="mx-auto d-block avatar-responsive">
                <v-img
                  src="@/assets/Maintenance/manutencao.png"
                  lazy-src="@/assets/Maintenance/manutencao.png"
                  contain
                />
              </v-avatar>
            </v-card-text>
            <v-card-text class="text-center">
              Tentaremos ser o mais breves possível!
            </v-card-text>
          </v-card>
        </v-container>
      </v-dialog>

      <v-col cols="12" md="4">
        <v-card
          :loading="loading"
          class="mx-auto my-12 align-self-center pa-5"
        >
          <template #progress>
            <v-progress-linear
              class="mb-8"
              color="primary"
              indeterminate
            />
          </template>

          <v-row justify="center">
            <v-avatar height="105" width="300" tile class="mt-2 mb-2 avatar-responsive">
              <img src="@/assets/fundo_conduril.png" />
            </v-avatar>
          </v-row>

          <v-row>
            <v-divider />
          </v-row>

          <v-card-title class="mt-2 primary--text justify-center title-responsive">
            ODC - Login
          </v-card-title>

          <v-form ref="login" :disabled="loading">
            <v-card-text>
              <v-row justify="center" class="mx-0" no-gutters>
                <v-col cols="12" md="8">
                  <v-btn
                    class="font-weight-bold center-button btn-responsive"
                    rounded
                    block
                    dark
                    color="#1e3582"
                    @click="microsoftLogin"
                  >
                    <div class="ms-btn-content">
                      <v-icon class="mr-2" :size="isTiny ? 16 : 24">mdi-microsoft</v-icon>

                      <div v-if="msEmailParts" class="ms-btn-label">
                        <span class="ms-btn-label-user">{{ msEmailParts.user }}</span>
                        <span class="ms-btn-label-domain">{{ msEmailParts.domain }}</span>
                      </div>

                      <span v-else>{{ microsoftButtonLabel }}</span>
                    </div>
                  </v-btn>
                </v-col>

                <v-col cols="12" md="8" align="center" class="mt-4">
                  <v-btn
                    rounded
                    depressed
                    color="#1e3582"
                    dark
                    outlined
                    class="btn-responsive"
                    @click="$msal.signOut()"
                    v-if="$msal.isAuthenticated()"
                  >
                    <v-icon class="mr-1">mdi-logout</v-icon>
                    Logout
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-form>

          <v-row justify="center" class="mt-5">
            <div class="col-12 text-center pb-0"><p class="mb-0">Powered By</p></div>
            <a target="_blank" href="https://www.dreamdealtech.pt/">
              <v-avatar height="45" width="140" tile class="mt-2 mb-2">
                <img src="@/assets/logo.png" />
              </v-avatar>
            </a>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <ErrorSnackbar :timeout="4000" v-model="error" :message="error_message" />
  </v-container>
</template>

<script>
import Input from "@/components/UI/Inputs/Input";
import Form from "@/components/UI/Forms/Form";
import ErrorSnackbar from "@/components/UI/Snackbars/ErrorSnackbar";
import Button from "@/components/UI/Buttons/Button";
import { msalMixin } from 'vue-msal';
import User from '@/api/User.js';
import System from '@/api/System.js';

export default {
  components: { Input, Form, ErrorSnackbar, Button },
  mixins: [msalMixin],
  data: () => ({
    showMaintenance: false,
    loading: false,
    error: false,
    error_message: "",
    system_status: null,
  }),
  mounted() {
    //this.cleanCookies();

    if (this.$store.state.user.id != undefined) this.$store.dispatch("logout");
    
    // Check if user was redirected here by the Auth.js interceptor
    const expiredMessage = sessionStorage.getItem("redirectedLogin");

    if (expiredMessage) {
      // if landing here from the redirect show the error snackbar
      this.error = true;
      this.error_message = expiredMessage;
        
      // remove the redirect message so the error doesn't persist 
      // if the user manually refreshes the login page later.
      sessionStorage.removeItem("redirectedLogin");
    }
    
    System.status().then((resp) => {
      this.system_status = resp.data;
      this.showMaintenance = this.system_status.maintenance.value != "0";
    });
  },
  methods: {
    cleanCookies() {
      document.cookie = `XSRF-TOKEN=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${process.env.VUE_APP_MY_DOMAIN}`;
      document.cookie.split(";").forEach((cookie) => {
        const [name] = cookie.split("=");
        document.cookie = `${name.trim()}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname}`;
      });
    },
    microsoftLogin() {
      if (this.$msal.isAuthenticated()) {
        this.loading = true;

        User.microsoftLogin(this.$msal.data.user.userName, this.$msal.data.user.idToken.oid)
          .then((res) => {
            if (res.data.two_factor) {
              this.$router.push("/mfa");
              throw { response: { status: 405, data: "Forçado para teste" } };
            }
            localStorage.setItem('auth', '1');
            this.$router.push("/dashboard");
          })
          .catch(async (err) => {
            this.loading = false;
            const status = err?.response?.status ?? 0;

            if (status === 405 || status === 0) {
              try {
                const res = await User.getSession();
                if (res.status === 200 && res.data) {
                  this.$router.push("/dashboard");
                  return;
                }
              } catch (_) {
                this.error = true;
                this.error_message = "Sessão expirada, por favor volte a autenticar-se.";
                return;
              }
            }

            if (err.response?.status == 422) {
              return;
            }
          });
      } else {
        const REDIRECT_URI = `${process.env.VUE_APP_API_URL}/login`;
        this.$msal.signIn({ redirectUri: REDIRECT_URI });
      }
    },
  },
  computed: {
    msEmailParts() {
      if (!this.$msal.isAuthenticated()) return null;
      if (!this.isTiny) return null;

      const email = this.user?.userName || this.$msal?.data?.user?.userName;
      if (!email || !email.includes("@")) return null;

      const [user, domain] = email.split("@");
      return { user, domain: `@${domain}` };
    },
    microsoftButtonLabel() {
      return this.isTiny
        ? "Login"
        : (this.$msal.isAuthenticated() ? (this.user?.userName || "Conta Microsoft") : "Usar conta Microsoft");
    },
    isTiny() {
      if (this.$vuetify.breakpoint.width >= 960 && this.$vuetify.breakpoint.width <= 1400) return true;
      return this.$vuetify.breakpoint.width <= 337;
    },
    user() {
      let user = null;
      if (this.msal.isAuthenticated) {
        user = { ...this.msal.user, profile: {} };
        if (this.msal.graph && this.msal.graph.profile) {
          user.profile = this.msal.graph.profile;
        }
      }
      return user;
    },
  },
};
</script>

<style scoped>
.bg-image {
  background-image: url("@/assets/fundo.jpg");
  background-position: center;
  background-size: cover;
}

.avatar-responsive { max-width: 100%; }
@media (max-width: 600px) {
  .avatar-responsive { width: 80vw !important; height: auto !important; }
}
@media (max-width: 360px) {
  .avatar-responsive { width: 86vw !important; }
}

.title-responsive { text-align: center; }
@media (max-width: 480px) { .title-responsive { font-size: 1.1rem !important; } }
@media (max-width: 360px) { .title-responsive { font-size: 1rem !important; } }

.btn-responsive { white-space: normal !important; }
.btn-responsive .v-btn__content { line-height: 1.2; }
@media (max-width: 480px) {
  .btn-responsive { min-height: 40px; padding-left: 12px; padding-right: 12px; }
  .btn-responsive .v-btn__content { font-size: 0.95rem; }
}
@media (max-width: 360px) {
  .btn-responsive { min-height: 38px; padding-left: 10px; padding-right: 10px; }
  .btn-responsive .v-btn__content { font-size: 0.85rem; }
}

.ms-btn-content {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ms-btn-label {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.05;
  text-align: center;
  font-size: 0.8em;
}

.ms-btn-label-domain {
  font-size: 0.6em;
}
</style>